export default {
  name: 'XYConfirmDialog',
  data() {
    return {
      title: '',
      titleCenter: false,
      visible: false,
      confirmBtnType: 'primary',
      confirmBtnText: '',
      cancelBtnText: '',
      message: '',
      onConfirm: null,
      onCancel: null
    };
  },
  computed: {
    isPrimaryConfirmBtn() {
      return this.confirmBtnType === 'primary';
    },
    isDangerConfirmBtn() {
      return this.confirmBtnType === 'danger';
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
    cancel() {
      if (typeof this.onCancel === 'function') {
        this.onCancel(this);
      }
      this.close();
    },
    confirm() {
      if (typeof this.onConfirm === 'function') {
        this.onConfirm(this);
      }
      this.close();
    }
  }
};